module.exports = __webpack_public_path__ + "static/img/bg_Graphics.31c3354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/bg_Graphics.png
// module id = LEcO
// module chunks = 70